export class RtcError extends Error {
    constructor(code, message, details = {}) {
        super(message);
        this.name = 'RtcError';
        this.code = code;
        this.status = details.status;
        this.retryAfterMs = details.retryAfterMs;
        this.matrixErrcode = details.matrixErrcode;
        this.reason = details.reason;
        if (details.cause !== undefined) {
            this.cause = details.cause;
        }
    }
}
export const toRtcError = (error, fallback = 'unknown') => {
    if (error instanceof RtcError) {
        return error;
    }
    const message = error instanceof Error ? error.message : String(error);
    return new RtcError(fallback, message, { cause: error });
};
export const silentLogger = {
    debug: () => undefined,
    info: () => undefined,
    warn: () => undefined,
    error: () => undefined,
};
export const systemClock = {
    now: () => Date.now(),
    setTimeout: (callback, ms) => setTimeout(callback, ms),
    clearTimeout: handle => clearTimeout(handle),
};
